export function factorial(number: number) {
  let rval = 1;
  for (let i = 2; i <= number; i++) {
    rval *= i;
  }
  return rval;
}
